console.log("slider-file");

let basePositions = [];

function getResponsiveBasePositions() {
  const ul = document.querySelector('.custom-grid-layout');
  const screenWidth = window.innerWidth;

  if (!ul) return [];

  const columnCount = parseInt(ul.dataset.columns) || 5;

  // For mobile (≤990px), fallback to 2-column layout
  if (screenWidth <= 990) {
    return [
      { top: 0, left: '0%' },
      { top: 60, left: '50%' }
    ];
  }

  // Generate base positions dynamically
  const positions = [];
  const topOffsets = [60, 120, 0, 180, 0, 150, 30]; // Customize as needed

  for (let i = 0; i < columnCount; i++) {
    const leftPercent = (100 / columnCount) * i;
    const top = topOffsets[i % topOffsets.length];
    positions.push({
      top: top,
      left: `${leftPercent}%`
    });
  }

  return positions;
}

function applyPositionsAndSetHeight() {
  const ul = document.querySelector('.custom-grid-layout');
  if (!ul) return;

  const lis = ul.querySelectorAll('li');
  basePositions = getResponsiveBasePositions();

  const columnHeights = {};
  let maxBottom = 0;

  // Initialize column heights
  basePositions.forEach(pos => {
    columnHeights[pos.left] = pos.top;
  });

  lis.forEach((li, index) => {
    const colIndex = index % basePositions.length;
    const base = basePositions[colIndex];
    const left = base.left;
    const currentTop = columnHeights[left];

    li.style.position = 'absolute';
    li.style.left = left;
    li.style.top = currentTop + 'px';

    const liHeight = li.offsetHeight || 150;
    const bottom = currentTop + liHeight;

    columnHeights[left] = bottom;
    if (bottom > maxBottom) {
      maxBottom = bottom;
    }
  });

  ul.style.position = 'relative';
  ul.style.height = maxBottom + 'px';
}

window.addEventListener('DOMContentLoaded', () => {
  applyPositionsAndSetHeight();

  window.addEventListener('resize', () => {
    applyPositionsAndSetHeight();
  });

  const observer = new MutationObserver(() => {
    applyPositionsAndSetHeight();
  });

  observer.observe(document.querySelector('.custom-grid-layout'), {
    childList: true,
    subtree: true,
    characterData: true,
  });
});
